export default __webpack_public_path__ + "static/media/Ballroll_00078.f5f49888.png";